$(document).ready(function() {
 
  $("#owl-demo").owlCarousel({

  navigation : true, // Show next and prev buttons

  slideSpeed : 1000,
  paginationSpeed : 400,

  items : 2, 
  itemsDesktop : false,
  itemsDesktopSmall : false,
  itemsTablet: false,
  itemsMobile : false

  });
 
});
